export const AI_PROCESSING_ZONE_EU = 'eu_data_zone_standard';
export const AI_PROCESSING_ZONE_GLOBAL = 'global_standard';

export const EU_AI_TOOLTIP =
    'When enabled, this project uses EU Data Zone Standard: AI requests are processed within the EU (GPT-5.4). ' +
    'When disabled, Global Standard applies and requests may be processed in other regions worldwide.';

export function aiProcessingZoneFromForm(processAiInEu) {
    return processAiInEu !== false ? AI_PROCESSING_ZONE_EU : AI_PROCESSING_ZONE_GLOBAL;
}

export function processAiInEuFromZone(zone) {
    return zone !== AI_PROCESSING_ZONE_GLOBAL;
}

export function aiProcessingZoneLabel(zone) {
    return zone === AI_PROCESSING_ZONE_GLOBAL
        ? 'Global Standard (GPT-5.4)'
        : 'EU Data Zone (GPT-5.4)';
}
